export const Colors = {
  primary: '#6f8196',
  primaryLight: '#cbd6e2',
  primaryDark: '#475360',
  secondary: '#dd7373',
};

export default Colors;
